import { render, staticRenderFns } from "./modal_actualizar_material.vue?vue&type=template&id=60147a84&"
import script from "./modal_actualizar_material.vue?vue&type=script&lang=js&"
export * from "./modal_actualizar_material.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports